import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/incentive-system/incentive-systems.css";
import RITabs from "./renewals-incentive-tabs/RITabs";
import HelmetWrapper from "../../HelmetWrapper";

const IncentiveSystem = () => {
  return (
    <HelmetWrapper title="WTF: Renewal/Incentive System Management">
      <Container className="bg-cloud-k" fluid>
        <Row>
          <Col>
            <RITabs />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default IncentiveSystem;
